(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kk-track"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kk-track-order')) return;

    // The six steps; the trip before the local carrier is one step, "On its way", whatever leg it is on.
    const STEPS = ['received', 'printing', 'packing', 'onway', 'local', 'delivered'];
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // line icons, 24px grid, 1.5 stroke (brand Icons; Lucide shapes for the ones the set doesn't have)
    const ALERT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v5.5M12 16.2v.3"/></svg>';
    const ICONS = {
      received: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.5 4.5h7v3h-7z"/><path d="M8.5 6H5.5v14.5h13V6h-3"/><path d="M9 14l2 2 4-4.5"/></svg>',
      printing: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 8.5v-5h10v5"/><path d="M7 17.5H4.5A1.5 1.5 0 0 1 3 16v-6a1.5 1.5 0 0 1 1.5-1.5h15A1.5 1.5 0 0 1 21 10v6a1.5 1.5 0 0 1-1.5 1.5H17"/><path d="M7 14h10v6.5H7z"/></svg>',
      packing: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/><path d="M8 5.3l8 4.5"/></svg>',
      onway: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.5 7h10v10h-10z"/><path d="M14.5 7v3.5M2.5 10h4.5M3.5 13.5H7M5 17h2"/></svg>',
      local: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11.5v10H2.5z"/><path d="M14 10h4l3.5 3.5v3H14"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
      delivered: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 11L12 4l8.5 7"/><path d="M6 9.5V20h12V9.5"/><path d="M10 20v-5.5h4V20"/></svg>',
    };
    const KNIFE = '<svg viewBox="0 0 48 16" aria-hidden="true" focusable="false"><path d="M2 8h26l6-4h8l4 4-4 4h-8l-6-4" /></svg>';

    // '2026-11-10' → 'Nov 10' (the web app sends days, not times: no time zone to get wrong)
    function day(iso) {
      const [, m, d] = String(iso).split('-').map(Number);
      return m && d ? `${MONTHS[m - 1]} ${d}` : '';
    }
    // 'Nov 10 – 16', 'Oct 30 – Nov 3', 'Nov 10'
    function range(from, to) {
      if (!to || from === to) return day(from);
      return from.slice(5, 7) === to.slice(5, 7) ? `${day(from)} – ${Number(to.slice(8, 10))}` : `${day(from)} – ${day(to)}`;
    }
    function el(tag, className, value) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value != null) node.textContent = value;
      return node;
    }

    class KkTrackOrder extends HTMLElement {
      connectedCallback() {
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        this.form = this.querySelector('form');
        this.top = this.querySelector('.kk-track__top');
        this.result = this.querySelector('.kk-track__result');
        this.button = this.form.querySelector('button');
        this.again = this.querySelector('.kk-track__again');
        // the six icons under the intro, as a picture of the trip, until an order is shown
        this.top.append(this.path(-1));
        // ?order=1082KIK fills the number in; ?order=1082KIK&t=<code> (our order email, or customer care) opens the order
        // straight away, without the form
        const params = new URLSearchParams(location.search);
        const order = params.get('order') || (location.hash.match(/^#([A-Za-z0-9]{3,20})$/) || [])[1];
        const bare = (value) => value.replace(/[#\s]/g, '');
        this.form.order.addEventListener('input', () => {
          const clean = bare(this.form.order.value);
          if (clean !== this.form.order.value) this.form.order.value = clean;
        });
        if (order) this.form.order.value = bare(order);
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.token = null;
          this.lookup();
        });
        this.again.querySelector('button').addEventListener('click', () => this.reset());
        if (order && params.get('t')) {
          this.token = params.get('t');
          this.form.hidden = true;
          this.lookup();
        } else if (this.dataset.endpoint) {
          // wakes the web app up while the customer types: the first answer after a quiet spell is the slow one
          fetch(this.dataset.endpoint).catch(() => {});
        }
      }

      async ask(body) {
        let answer = { ok: false, error: 'unavailable' };
        // an answer takes 2 to 5 seconds; one that hangs is dropped and asked again once
        for (let attempt = 0; attempt < 2; attempt++) {
          const timer = new AbortController();
          const stop = setTimeout(() => timer.abort(), 15000);
          try {
            // text/plain keeps it a simple request: no preflight, which Apps Script cannot answer
            const res = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify(body),
              signal: timer.signal,
            });
            answer = await res.json();
            break;
          } catch {
            answer = { ok: false, error: 'unavailable' };
          } finally {
            clearTimeout(stop);
          }
        }
        return answer;
      }

      async lookup() {
        const order = this.form.order.value.trim();
        const email = this.form.email.value.trim();
        if (!this.token && (!order || !email)) return this.show(this.message('missing'));
        if (!this.dataset.endpoint) return this.show(this.message('unavailable'));
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.show(this.loading());
        const answer = await this.ask(this.token ? { order, token: this.token } : { order, email });
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        if (!answer.ok) {
          // a link that no longer works falls back to the form
          if (this.token) this.form.hidden = false;
          return this.show(this.message(answer.error));
        }
        // the answer takes the page: the form and the headline step aside until "Track another order"
        this.form.hidden = true;
        this.top.hidden = true;
        this.again.hidden = false;
        this.show(this.order(answer));
      }

      reset() {
        this.token = null;
        this.result.hidden = true;
        this.result.replaceChildren();
        this.form.hidden = false;
        this.top.hidden = false;
        this.again.hidden = true;
        this.form.order.value = '';
        this.form.order.focus();
      }

      show(node) {
        this.result.replaceChildren(node);
        this.result.hidden = false;
        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // a knife running along a dashed cut line
      loading() {
        const box = el('div', 'kk-track__loading');
        const line = el('div', 'kk-track__cutline');
        line.setAttribute('aria-hidden', 'true');
        const knife = el('span', 'kk-track__knife');
        knife.innerHTML = KNIFE;
        line.append(knife);
        box.append(line, el('p', 'kk-track__loading-text', this.copy.loading));
        return box;
      }

      message(error) {
        const box = el('div', 'kk-track__message');
        box.append(el('p', '', this.copy[error] || this.copy.unavailable));
        return box;
      }

      // — the order —————————————————————————————————————————————

      order(a) {
        const box = el('div', 'kk-track__order');
        const meta = el('div', 'kk-track__meta');
        meta.append(el('p', 'kk-label', this.copy.order.replace('[order]', a.order)));
        if ((a.items || []).length) meta.append(el('p', 'kk-track__items', a.items.join(' + ')));
        box.append(meta);
        if (STEPS.indexOf(a.step) < 0) {
          box.append(this.message(a.step === 'cancelled' ? 'cancelled' : 'unknown'));
          return box;
        }
        const when = this.when(a);
        if (when) box.append(el('h2', 'kk-track__when', when));
        if (a.delay) box.append(this.delay(a.delay));
        if (a.problem) box.append(this.problem(a.problem));
        box.append(this.timeline(a));
        // the order number and its contents close the answer
        box.append(box.firstChild);
        return box;
      }

      // "Arrives Nov 10 – 16", "Delivered Nov 3", "Running late" (not shipped yet), "Delivery issue" (the carrier
      // reported a problem), or "Arriving soon" (window passed)
      when(a) {
        if (a.step === 'delivered') return a.dates.delivered ? this.copy.delivered_head.replace('[date]', day(a.dates.delivered)) : this.copy.step_delivered;
        if (a.delay) return this.copy.delayed_head;
        if (a.problem) return this.copy.problem_head;
        if (!a.estimate) return '';
        if (a.estimate.late) return this.copy.late;
        return this.copy.arrives.replace('[dates]', range(a.estimate.from, a.estimate.to));
      }

      path(at, a) {
        const list = el('ol', 'kk-track__path');
        if (at < 0) list.setAttribute('aria-hidden', 'true');
        STEPS.forEach((key, i) => {
          const done = i < at || (i === at && key === 'delivered');
          const current = i === at && !done;
          const li = el('li', `kk-track__stop${done ? ' is-done' : ''}${current ? ' is-current' : ''}`);
          if (current) li.setAttribute('aria-current', 'step');
          const icon = el('span', 'kk-track__icon');
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = ICONS[key];
          li.append(icon, el('p', 'kk-track__stop-name', this.copy['path_' + key] || this.copy['step_' + key]));
          const date = a && (a.dates || {})[key];
          if (date && (done || current)) li.append(el('p', 'kk-track__stop-date', day(date)));
          list.append(li);
        });
        return list;
      }

      // the path, then the step the kit is at in a panel pointing up at its icon
      // the apology for an order that hasn't shipped on time, with the trip time once it leaves
      delay(d) {
        const box = el('div', 'kk-track__delay');
        box.setAttribute('role', 'status');
        const icon = el('span', 'kk-track__delay-icon');
        icon.innerHTML = ALERT;
        const body = el('div', 'kk-track__delay-body');
        body.append(el('p', 'kk-track__delay-title', this.copy.delay_title));
        const days = (d.transit || []).length === 2 ? `${d.transit[0]} to ${d.transit[1]}` : '';
        body.append(el('p', 'kk-track__text', this.copy.delay_text.replace('[days]', days)));
        box.append(icon, body);
        return box;
      }

      // the carrier couldn't deliver: what it said, and how to reach it (the delivery is between the customer and the carrier now)
      problem(p) {
        const carrier = p.carrier || 'your carrier';
        const fill = (text) => String(text || '').replace(/\[carrier\]/g, carrier).replace(/\[date\]/g, day(p.day));
        const box = el('div', 'kk-track__delay kk-track__problem');
        box.setAttribute('role', 'alert');
        const icon = el('span', 'kk-track__delay-icon');
        icon.innerHTML = ALERT;
        const body = el('div', 'kk-track__delay-body');
        body.append(el('p', 'kk-track__delay-title', this.copy.problem_title));
        body.append(el('p', 'kk-track__text', fill(this.copy['problem_' + p.kind] || this.copy.problem_attempt)));
        if (p.says) body.append(el('p', 'kk-track__says', `${fill(this.copy.problem_says)} “${p.says}”`));
        body.append(el('p', 'kk-track__text', fill(this.copy.problem_contact)));
        const ways = el('ul', 'kk-track__contacts');
        const way = (label, text, href) => {
          const li = el('li');
          li.append(el('span', 'kk-label', label));
          const link = el('a', '', text);
          link.href = href;
          if (/^https?:/.test(href)) { link.target = '_blank'; link.rel = 'noopener'; }
          li.append(link);
          ways.append(li);
        };
        if (p.phone) way(fill(this.copy.problem_call), p.phone, 'tel:' + p.phone.replace(/[^\d+]/g, ''));
        if (p.email) way(fill(this.copy.problem_email), p.email, 'mailto:' + p.email);
        if (p.url) way(fill(this.copy.problem_track), [p.carrier, p.number].filter(Boolean).join(' '), p.url);
        body.append(ways);
        box.append(icon, body);
        return box;
      }

      timeline(a) {
        const at = STEPS.indexOf(a.step);
        const key = STEPS[at];
        const late = !!(a.estimate && a.estimate.late);
        const box = el('div', 'kk-track__journey');
        box.append(this.path(at, a));
        const panel = el('div', 'kk-track__panel');
        panel.style.setProperty('--at', at);
        if (key !== 'delivered') panel.append(el('p', 'kk-label kk-track__panel-label', this.copy.now));
        panel.append(el('p', 'kk-track__panel-name', this.copy['step_' + key]));
        const words = key === 'delivered' || a.delay || a.problem ? '' : late && key !== 'received' ? this.copy.text_late : this.copy['text_' + key];
        if (words) panel.append(el('p', 'kk-track__text', words));
        if ((a.tracking || []).length) {
          const links = el('p', 'kk-track__links');
          a.tracking.forEach((t, n) => {
            // "USPS 9261…", "GOFO GF…", or the number alone for a carrier the sheet doesn't recognize
            const link = el('a', '', [t.carrier, t.number].filter(Boolean).join(' '));
            link.href = t.url;
            link.target = '_blank';
            link.rel = 'noopener';
            if (n) links.append(' · ');
            links.append(link);
          });
          panel.append(links);
        } else if (at < STEPS.indexOf('onway') && !a.delay) {
          // (On its way already says the tracking number is coming)
          panel.append(el('p', 'kk-track__text kk-track__text--soon', this.copy.tracking_soon));
        }
        box.append(panel);
        return box;
      }
    }

    customElements.define('kk-track-order', KkTrackOrder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
